/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TranslationsStrictHttpResponse } from '../../translations-strict-http-response';
import { TranslationsRequestBuilder } from '../../translations-request-builder';

import { TranslationsTranslateCustomTemplateRequestDto } from '../../models/translations-translate-custom-template-request-dto';
import { TranslationsTranslateCustomTemplateResponseDto } from '../../models/translations-translate-custom-template-response-dto';

export interface CustomTemplatesControllerTranslateCustomTemplate$Params {

/**
 * Tenant name/slug for multi-tenancy isolation.
 */
  name: string;
      body: TranslationsTranslateCustomTemplateRequestDto
}

export function customTemplatesControllerTranslateCustomTemplate(http: HttpClient, rootUrl: string, params: CustomTemplatesControllerTranslateCustomTemplate$Params, context?: HttpContext): Observable<TranslationsStrictHttpResponse<TranslationsTranslateCustomTemplateResponseDto>> {
  const rb = new TranslationsRequestBuilder(rootUrl, customTemplatesControllerTranslateCustomTemplate.PATH, 'post');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as TranslationsStrictHttpResponse<TranslationsTranslateCustomTemplateResponseDto>;
    })
  );
}

customTemplatesControllerTranslateCustomTemplate.PATH = '/o2-translations/custom-templates/translate/{name}';
